import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';
import { faUnlockAlt } from '@fortawesome/free-solid-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('User_Username'),
			accessor: 'username',
			sortable: true
		},
		{
			header: t('User_Email'),
			accessor: 'email',
			sortable: true
		},
		{
			header: t('User_Role'),
			accessor: 'role.name',
			sortable: false,
			cell: name => t(`SystemUserRole_${name}`, name)
		},
		{
			header: t('User_Created'),
			accessor: 'created',
			cell: (created) => (ui.formatDateTime(created)),
			sortable: true
		},
		{
			header: t('User_LastUsedDate'),
			accessor: 'lastUsedDate',
			cell: (lastUsedDate) => (ui.formatDateTime(lastUsedDate)),
			sortable: false
		},
		{
			header: t('User_Enabled'),
			accessor: 'enabled',
			sortable: true,
			cell: (enabled) => (ui.formatBoolean(enabled))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, user) => (
				<div>
					<Link to={`/users/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Link>&nbsp;
					<Link to={`/permissions/${('user')}/${id}/${user.username}`} className='btn btn-teal'><FontAwesomeIcon icon={faUnlockAlt} /> {t('Common_Permissions')}</Link>
				</div>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/users/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);